import React from "react";
import Breadcrumbs from "../components/pageProps/Breadcrumbs";
import ShopSideNav from "../components/pageProps/shopPage/ShopSideNav";
import Product from "../components/home/Products/Product.js"; 
import {
  fan1,
  fan2,
  fan3,
  fan4,
  fan5,
  fan6,
  fan7,
  fan8,
  fan9,
  fan10,
  fan11,
  fan12,
  } from "../assets/images/index"; 

const Fans = () => {
  const products = [
    {
      _id: "1011",
      img: fan1,
      productName: "Royal Deluxe Ceiling Fan",
      price: "9900",
      color: "Royal",
      badge: false,
      des: "SKU: Royal Deluxe Ceiling Fans-56/COOPER-(White)-0000001 <br> The Deluxe Ceiling fan is specially designed with superior performance and durability in mind, it is perfect for the office, home, or projects. The simple yet elegant design makes it is perfect for any space.  "
    },
    {
      _id: "1012",
      img: fan2,
      productName: "Royal Saver Ceiling Fan",
      price: "10200",
      color: "Energy",
      badge: false,
      des: "SKU: Royal Smart Series ESF (White)-0000001Royal Energy Saver Fans are designed on the principle of conserving energy to preserve the planet. To ensure the provision of energy-efficient solutions, Royal Fans takes pride in manufacturing Pakistan's first energy saver fans that use less energy, and are not heavy on the electricity bills."
    },
    {
      _id: "1013",
      img: fan3,
      productName: "Royal Hi-Standard Ceiling Fan",
      price: "8700",
      color: "Royal",
      badge: false,
      des: "SKU: Royal Deluxe Hi Standard Ceiling Fan-56/COPPER-(Off-White)-0000004Royal Deluxe Series are carefully crafted to comfort you in the hot summer days. The attractive design and energy-saving technology is a relief worth enjoying. Whenever the fan is turned on it casts a spell of peace and convenience."
    },
    {
      _id: "1014",
      img: fan4,
      productName: "Royal Passion Ceiling Fan - GRACE",
      price: "9900",
      color: "Royal",
      badge: false,
      des: "SKU: Royal Deluxe Passion Ceiling Fans-56/COOPER-(Off-White Sheesham Wood)-0000004The Passion Ceiling fan is a customer favorite and a best seller. It has an elegant design with multiple decor and color options to suit your aesthetic need. It is perfect for your home or office. "
    },
    {
      _id: "1015",
      img: fan5,
      productName: "Royal Petite Bracket Fan",
      price: "6900",
      color: "Royal",
      badge: false,
      des: "SKU: Royal Deluxe Petite Bracket Fan-12/COPPER-(Off-White)-0000002Be it your corridor, terrace, lobby, or veranda, the Royal Petite Fan is the best fit any place where space is limited. With its small wing blades and alluring shades of pearl white and impressive black, this fan is a petite powerhouse."
    },
    {
      _id: "1016",
      img: fan6,
      productName: "Royal Platinum Ceiling Fan",
      price: "9900",
      color: "Royal",
      badge: false,
      des: "SKU: Royal Deluxe Ceiling Fans-56/COOPER-(Off-White)-0000003Royal Deluxe Series  are carefully crafted to comfort you in the hot summer days. The attractive design and energy-saving technology is a relief worth enjoying. Whenever the fan is turned on it casts a spell of peace and convenience."
    },
    {
      _id: "1017",
      img: fan7,
      productName: "Royal Water Proof Ceiling Fan - Majesty",
      price: "9900",
      color: "Royal",
      badge: false,
      des: "SKU: Royal Deluxe Water Proof Ceiling Fans-56/COPPER-(Off-White)-0000002Our Water Proof Ceiling Fans are designed to work in open areas, mosques, etc. that are exposed to extreme weather conditions as well as to keep them safe from dust and moisture. If you are planning to invest in a fan that has the quality to perform well along with being waterproof, then you have come to the right place.      "
    },
    {
      _id: "1018",
      img: fan8,
      productName: "Royal RL-040- Smart Lifestyle ACDC Fan",
      price: "13200",
      color: "Royal",
      badge: false,
      des: "SKU: Royal Lifestyle-RL-040(Off-White Sheesham Wood)-0000001Our Smart LifeStyle AC/DC  fans are designed to provide constant performance in areas where electricity shortage is an issue. You will find them worth everything when it comes to price, performance, and the fact that it can be used on DC batteries. In addition to that, remote"
    },
    {
      _id: "1019",
      img: fan9,
      productName: "Royal RL-050 - Smart Lifestyle ACDC Fan",
      price: "13200",
      color: "Royal",
      badge: false,
      des: "SKU: Royal Lifestyle-RL-050(Off White Pinewood)-0000003Our Smart LifeStyle AC/DC  fans are designed to provide constant performance in areas where electricity shortage is an issue. You will find them worth everything when it comes to price, performance, and the fact that it can be used on DC batteries. In addition to that, remote"
    },
    {
      _id: "1020",
      img: fan10,
      productName: "Royal Smart Prime ACDC Ceiling Fan - Prime",
      price: "10200",
      color: "Royal",
      badge: false,
      des: "SKU: Royal Smart Prime Ceiling Fans(Off-White)-0000003fans are designed to provide constant performance in areas where electricity shortage is an issue. You will find them worth"
    },
    {
      _id: "1021",
      img: fan11,
      productName: "Ornament - Smart Lifestyle ACDC Fan",
      price: "18600",
      color: "Ornament",
      badge: false,
      des: "SKU: Ornament 001Our Smart LifeStyle AC/DC  fans are designed to provide constant performance in areas where electricity shortage is an issue. You will find them worth everything when it comes to price, performance, and the fact that it can be used on DC batteries. In addition to that, remote"
    },
    {
      _id: "1022",
      img: fan12,
      productName: "Royal Passion Grace - Prime ACDC Ceiling Fan",
      price: "10200",
      color: "Royal",
      badge: false,
      des: "SKU: Royal Smart Passion ACDC Grace 00004Our Smart AC/DC  fans are designed to provide constant performance in areas where electricity shortage is an issue. You will find them worth"
    },
    {
      _id: "1011",
      img: fan1,
      productName: "Royal Deluxe Ceiling Fan",
      price: "9900",
      color: "Royal",
      badge: false,
      des: "SKU: Royal Deluxe Ceiling Fans-56/COOPER-(White)-0000001 <br> The Deluxe Ceiling fan is specially designed with superior performance and durability in mind, it is perfect for the office, home, or projects. The simple yet elegant design makes it is perfect for any space.  "
    },
    {
      _id: "1012",
      img: fan2,
      productName: "Royal Energy Saver Ceiling Fan",
      price: "10200",
      color: "Royal",
      badge: false,
      des: "SKU: Royal Smart Series ESF (White)-0000001Royal Energy Saver Fans are designed on the principle of conserving energy to preserve the planet. To ensure the provision of energy-efficient solutions, Royal Fans takes pride in manufacturing Pakistan's first energy saver fans that use less energy, and are not heavy on the electricity bills."
    },
    {
      _id: "1013",
      img: fan3,
      productName: "Royal Hi-Standard Ceiling Fan",
      price: "8700",
      color: "Royal",
      badge: false,
      des: "SKU: Royal Deluxe Hi Standard Ceiling Fan-56/COPPER-(Off-White)-0000004Royal Deluxe Series are carefully crafted to comfort you in the hot summer days. The attractive design and energy-saving technology is a relief worth enjoying. Whenever the fan is turned on it casts a spell of peace and convenience."
    },
    {
      _id: "1014",
      img: fan4,
      productName: "Royal Passion Ceiling Fan - GRACE",
      price: "9900",
      color: "Royal",
      badge: false,
      des: "SKU: Royal Deluxe Passion Ceiling Fans-56/COOPER-(Off-White Sheesham Wood)-0000004The Passion Ceiling fan is a customer favorite and a best seller. It has an elegant design with multiple decor and color options to suit your aesthetic need. It is perfect for your home or office. "
    },
  ];

  return (
    <div className="max-w-container mx-auto px-4">
      <Breadcrumbs title="Fans" />
      <div className="w-full h-full flex pb-20 gap-10">
        <div className="w-[20%] lgl:w-[25%] hidden mdl:inline-flex h-full">
          <ShopSideNav />
        </div>
        <div className="w-full mdl:w-[80%] lgl:w-[75%] h-full flex flex-col gap-10">
          <div className="w-full grid grid-cols-1 md:grid-cols-2 lgl:grid-cols-3 xl:grid-cols-4 gap-10">
            {products.map((product) => (
              <Product
                key={product._id}
                _id={product._id}
                img={product.img}
                productName={product.productName}
                price={product.price}
                color={product.color}
                badge={product.badge}
                des={product.des}
              />
            ))}
          </div>
        </div>
      </div>
        </div>
  );
};

export default Fans;
